import React from 'react';
import { ButtonGroup, } from 'reactstrap';
import { NavLink as RouterLink, withRouter } from 'react-router-dom';
import './index.css'
import { connect } from 'react-redux';
import { orgAdminAction, saveTeamDetailsAction } from '../../../_actions';


class AnalysisNvaBar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            orgId: null,
            data: [
                {
                    subNavName: 'DashBoard',
                    state: {prevPath: this.props.location.pathname},
                    link: `/organisation/${this.props.orgId}/user/dashboard`,
                    cata: "dashboard",
                },
                {
                    subNavName: 'SWOT',
                    state: {prevPath: this.props.location.pathname},
                    link: `/organisation/${this.props.orgId}/user/swot`,
                    cata: "swot",
                },
                {
                    subNavName: 'Focus Areas',
                    state: {prevPath: this.props.location.pathname},
                    link: `/organisation/${this.props.orgId}/user/focus-area`,
                    cata: "focus-area",
                },
                {
                    subNavName: 'Review Questions',
                    state: {prevPath: this.props.location.pathname},
                    link: `/organisation/${this.props.orgId}/user/review-questions`,
                    cata: "review-questions",
                },
                {
                    subNavName: 'Collaboration',
                    state: {prevPath: this.props.location.pathname},
                    link: `/organisation/${this.props.orgId}/user/collaboration`,
                    cata: "collaboration",
                },
                {
                    subNavName: 'Team  Fitment',
                    state: {prevPath: this.props.location.pathname},
                    link: `/organisation/${this.props.orgId}/user/compability`,
                    cata: "compability",
                },
                {
                    subNavName: 'Role Fitment',
                    link: `/organisation/${this.props.orgId}/user/role-fitment`,
                    cata: "role-fitment",
                },
                {
                    subNavName: 'Competency',
                    state: {prevPath: this.props.location.pathname},
                    link: `/organisation/${this.props.orgId}/user/competency-indicator`,
                    cata: "competency",
                },
                {
                    subNavName: 'L&D',
                    state: {prevPath: this.props.location.pathname},
                    link: `/organisation/${this.props.orgId}/user/learning-and-development`,
                    cata: "l&d",
                },
                {
                    subNavName: 'Attrition Predictor',
                    state: {prevPath: this.props.location.pathname},
                    link: `/organisation/${this.props.orgId}/user/attrition-predictor`,
                    cata: "attrition-predictor",
                },
                // {
                //     subNavName: 'Hiring Probability',
                //     link: `/organisation/${this.props.orgId}/user/hiring-probability`,
                //     cata: "hiring-probability",
                // },
                {
                    subNavName: 'Virtual Teams',
                    state: {prevPath: this.props.location.pathname},
                    link: `/organisation/${this.props.orgId}/my-teams`,
                    cata: "virtual-teams",
                }
            ]
        }
    }

    componentDidMount() {
        this.setState({
            orgId: +this.props.match.params.id
        })

    }

    render() {
        return (
            <div className={this.props.analyticsType == 'people' ? `d-flex flex-row analyze-nav-bar-people` : `d-flex flex-row analyze-nav-bar`}>
                <ButtonGroup className="button">
                    {/* {
                    subNavName: 'SWOT',
                    link: `/organisation/${props.match.params.id}/user/swot/0`,
                    image: swot,
                    text: "Strengths, Weaknesses, Opportunities, & Threats",
                    cata: "swot",
                }, */}
                    <RouterLink to={{pathname: `/organisation/${this.props.match.params.id}/user/dashboard`, state: {prevPath: this.props.location.pathname}}} className={this.props.analyticsType == 'people' ? 'd-flex align-items-center btn-secondary-people text-center' : 'd-flex align-items-center btn-secondary text-center'} activeClassName={this.props.analyticsType == 'people' ? "active-background-people" : "active-background"} >
                        {'DashBoard'}
                    </RouterLink>
                    {
                        this.state.data.map((val, key) => {
                            return (
                                this.props.analyticsData &&
                                this.props.analyticsData.map(
                                    (data, i) => {
                                        return (
                                            data.module_list__module_name.toLowerCase() === val.subNavName.toLowerCase() &&
                                            <RouterLink onClick={() => {this.props.clearData ? this.props.clearData() : null}} key={key} to={{pathname: val.link, state: val.state}} className={this.props.analyticsType == 'people' ? 'd-flex align-items-center btn-secondary-people text-center' : 'd-flex align-items-center btn-secondary text-center'} activeClassName={this.props.analyticsType == 'people' ? "active-background-people" : "active-background"} >
                                                {val.subNavName}
                                            </RouterLink>
                                        )
                                    }
                                )
                            )


                        })
                    }
                </ButtonGroup>
            </div>
        );
    }

}

function mapStateToProps(state) {
    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    return {
        getModulePermissionsListResponse,
    }
}

const connectedForm = connect(mapStateToProps)(AnalysisNvaBar);

export default withRouter(connectedForm);



// WEBPACK FOOTER //
// ./src/_components/common/AnalysisNavBar/index.js